import apiRequest from "utils/apiRequestWithErrorCode";
import { fetchAccounts } from "utils/api/accounts";
import { fetchGroups } from "utils/api/groups";
import { ReviewerOption } from "../types";
import { Variable } from "@dashboard-v3/api";

export async function getReviewerOptions(
  text: string
): Promise<ReviewerOption[]> {
  const textToSearch = text?.trim()?.toUpperCase();
  if (!textToSearch) return [];

  const [tags, accounts, groups, variables] = await Promise.all([
    getTags(textToSearch),
    getAccounts(textToSearch),
    getGroups(textToSearch),
    getVariables(textToSearch),
  ]);

  const options = [...tags, ...accounts, ...groups, ...variables];

  return options;
}

export async function getAccounts(search?: string): Promise<ReviewerOption[]> {
  const accounts = await fetchAccounts({
    limit: 100000,
    partialEmailOrAlias: search,
    type: "member",
  });

  const options = accounts.map(
    ({ email }) =>
      ({
        key: `EMAIL-${email}`,
        label: email,
        type: "EMAIL",
        value: email,
      } as ReviewerOption)
  );

  return options;
}

export async function getGroups(search?: string): Promise<ReviewerOption[]> {
  const groups = await fetchGroups(100000, 0, search);

  const options = groups.map(
    ({ id, name }) =>
      ({
        key: id,
        label: name,
        type: "GROUP",
        value: id,
      } as ReviewerOption)
  );

  return options;
}

export async function getVariables(search?: string): Promise<ReviewerOption[]> {
  const variables = await apiRequest<Variable[]>(
    "GET",
    `/variables?partialName=${search}`
  );

  const options = variables.map(
    ({ id, name }) =>
      ({
        key: id,
        type: "VARIABLE",
        label: name,
        value: id,
      } as ReviewerOption)
  );

  return options;
}

export async function getTags(search?: string): Promise<ReviewerOption[]> {
  const tags = await apiRequest<string[]>("GET", "/accounts/tags");

  const options = tags.reduce<ReviewerOption[]>((options, tag) => {
    if (!search || tag.toLowerCase().startsWith(search.toLowerCase())) {
      options.push({
        key: `TAG-${tag}`,
        type: "TAG",
        label: tag,
        value: tag,
      });
    }
    return options;
  }, []);

  return options;
}
